//import Vue from 'vue';
import axios from 'axios';
//import qs from 'qs';
import Util from './util';
import md5 from "md5";
import store from '../store/index'

var ua = sessionStorage.getItem('ua');
axios.defaults.timeout = 30000;
if ((window.location.host).indexOf('test') == -1) {
    // axios.defaults.baseURL = 'https://wygpc.iartschool.com:8443/';
    // axios.defaults.baseURL = 'https://slb.iartschool.com:7443/';
    axios.defaults.baseURL = 'https://im.iartschool.com:8443/';
} else {
    axios.defaults.baseURL = 'http://test.iartschool.com:8080/';
}
// axios.defaults.baseURL = 'https://im.iartschool.com:8443/';

//https://wygpc.iartschool.com:8443 回归地址
// /iart-api-scm/api/scm/activity/queryActivityDetail
//axios.defaults.baseURL = 'http://test.iartschool.com:18080/';

// axios.defaults.baseURL = 'https://slb.iartschool.com:7443' // 'https://wygpc.iartschool.com:8443';
//axios.defaults.baseURL = 'http://192.168.1.53:8080/';
// axios.defaults.baseURL = 'http://im.iartschool.com:8080/';
axios.interceptors.response.use(function(response) {
    if (response.headers && response.headers.authorization) {
        store.state.state.userinfo='';
        localStorage.setItem('authorization', response.headers.authorization);
    } else {
        //localStorage.setItem('authorization', '');
    }
    return response;
}, function(error) {
    return Promise.reject(error);
});
axios.interceptors.request.use(
    config => {
        if (localStorage.getItem('authorization')) {
            config.headers.Authorization = localStorage.getItem('authorization');
        }
        var timestamp = (new Date()).getTime();
        config.headers['platform'] = (ua == 'iartIos' || ua == 'iartAndroid') ? 'app' : 'weixin';
        config.headers['uuid'] = typeof(localStorage.getItem('uuid') != 'undefined') && localStorage.getItem('uuid') != null ? localStorage.getItem('uuid') : '';
        config.headers['locationx'] = typeof(localStorage.getItem('locationx') != 'undefined') && localStorage.getItem('locationx') != null ? localStorage.getItem('locationx') : '';
        config.headers['locationy'] = typeof(localStorage.getItem('locationy') != 'undefined') && localStorage.getItem('locationy') != null ? localStorage.getItem('locationy') : '';
        config.headers['network'] = typeof(localStorage.getItem('network') != 'undefined') && localStorage.getItem('network') != null ? localStorage.getItem('network') : '';
        config.headers['osversion'] = typeof(localStorage.getItem('osversion') != 'undefined') && localStorage.getItem('osversion') != null ? localStorage.getItem('osversion') : '';
        config.headers['version'] = typeof(localStorage.getItem('version') != 'undefined') && localStorage.getItem('version') != null ? localStorage.getItem('version') : '';
        config.headers['IART-timestamp'] = timestamp;
        config.headers[Util.base64('SUFSVC1hY2Nlc3NrZXk=')] = 'q19HGguFQenGWcDkfvPSZQ==';
        config.headers['IART-nonce'] = timestamp.toString() + (Math.floor(Math.random() * 9000) + 1000);
        config.headers[Util.base64('SUFSVC1zaWduYXR1cmU=')] = md5(JSON.stringify(config.data) + `&${Util.base64('YWNjZXNzU2VjcmV0')}=Wh8r+dtPkbLCeEXRoEsNegbUAJ7cO2bi2gg7WuR0zpM=&timestamp=` + timestamp).toUpperCase();
        /*  config.headers = {
             'Content-Type': 'application/x-www-form-urlencoded',
             'Authorization': ' window.sessionStorage.getItem("cookie")'
         } */
        return config;
    },
    error => {
        return Promise.reject(err);
    }
);

export function get(url, params = {}) {
    if (sessionStorage.getItem('sharecode') && typeof(sessionStorage.getItem('sharecode')) != 'undefined') {
        Object.assign(params, {
            'customercode': sessionStorage.getItem('sharecode')
        })
    }
    return new Promise((resolve, reject) => {
        axios.get(url, {
                params: Object.assign(params, {
                    _: (new Date()).getTime()
                })
            }, )
            .then(response => {
                response.data.httpTime = response.headers && response.headers.date ? response.headers.date : '';
                resolve(response.data);
            })
            .catch(err => {
                if (err.response && err.response.data.code == 503) {

                } else {
                    Util.toast({
                        msg: 'Network busy. Please try again later!',
                        type: 'fail'
                    })

                }
            })
    })
}


export function post(url, data = {}, o) { //o 是否是表单提交
    if (sessionStorage.getItem('sharecode') && typeof(sessionStorage.getItem('sharecode')) != 'undefined') {
        Object.assign(data, {
            'customercode': sessionStorage.getItem('sharecode')
        })
    }
    return new Promise((resolve, reject) => {
        //o ? data : qs.stringify(data)
        axios.post(url, data)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
                if (err.response && err.response.data.code == 503) {} else {
                    Util.toast({
                        msg: 'Network busy. Please try again later!',
                        type: 'fail'
                    })
                }
            })
    })
}